import { useAppRole } from '../../../../app/routes/useRolePath';
import { roles } from '../../../../app/routes/paths';
import { MentorProfilePage } from '../../../mentor';
import { StudentProfilePage } from '../../../student';

/**
 * Role-scoped education profile at `/{role}/profile`.
 * Mentor / student pages stay as child views of this wrapper.
 */
export function EducationProfilePage() {
  const role = useAppRole();
  if (role === roles.MENTOR) return <MentorProfilePage />;
  if (role === roles.CLIENT) return <StudentProfilePage />;
  return null;
}

export default EducationProfilePage;
